import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { EffectFade, Autoplay, Pagination } from 'swiper';

SwiperCore.use([EffectFade, Autoplay, Pagination]);

const SlidingHero = () => {
  return (
    <div className="mb-5 SlidingHero">
      <Swiper
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        speed={1000}
      >
        <SwiperSlide>
          <a href="#" target="_blank" referrerPolicy="no-referrer">
            <img
              src="https://www.bca.co.id/-/media/Images/Banner/20220405-promo-sakuku-banner"
              alt="Reward BCA"
              className="rounded w-100"
            />
          </a>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default SlidingHero